export default "__VITE_ASSET__af342a02__"